import {
  getProjectVideoProvider,
  normalizeVideoProvider,
} from "./projectRuntime";
import {
  isWanxVideoModel,
  normalizeWanxVideoModel,
  normalizeWanxVideoResolution,
  WANX_VIDEO_MODEL,
  WANX_VIDEO_PROVIDER,
} from "./wanxVideoCapabilities";

const firstText = (...values) => {
  for (const value of values) {
    const text = String(value ?? "").trim();
    if (text) return text;
  }
  return "";
};

const integerSeconds = (value, fallback) => {
  const parsed = Number.parseInt(String(value ?? "").replace(/s/gi, "").trim(), 10);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const getSequenceShotImage = (shot = {}) => firstText(
  shot.generated_image,
  shot.generatedImage,
  shot.first_frame_image,
  shot.firstFrameImage,
);

export const resolveSequenceVideoRuntime = ({
  projectId,
  provider = "vidu",
  model = "viduq3-pro",
  resolution,
} = {}) => {
  const projectProvider = normalizeVideoProvider(getProjectVideoProvider(projectId, ""));
  if (projectId && !projectProvider) {
    return {
      provider: "",
      model: "",
      resolution: "720p",
      minDuration: 4,
      maxDuration: 15,
      fixed: true,
      unavailable: true,
    };
  }
  const rawProvider = firstText(provider, "vidu").toLowerCase();
  const rawModel = firstText(model);
  if (rawProvider === WANX_VIDEO_PROVIDER || isWanxVideoModel(rawProvider) || isWanxVideoModel(rawModel)) {
    return {
      provider: WANX_VIDEO_PROVIDER,
      model: normalizeWanxVideoModel(isWanxVideoModel(rawModel) ? rawModel : rawProvider, WANX_VIDEO_MODEL),
      resolution: normalizeWanxVideoResolution(resolution, "1080P"),
      minDuration: 2,
      maxDuration: 30,
      fixed: false,
    };
  }
  return {
    provider: firstText(provider, "vidu"),
    model: firstText(model, "viduq3-pro"),
    resolution: "720p",
    minDuration: 1,
    maxDuration: 16,
    fixed: false,
  };
};

export const normalizeSequenceVideoDuration = (provider, value, fallback = 5) => {
  const wanx = String(provider || "").trim().toLowerCase() === WANX_VIDEO_PROVIDER
    || isWanxVideoModel(provider);
  const min = wanx ? 2 : 1;
  const max = wanx ? 30 : 16;
  const seconds = integerSeconds(value, fallback);
  return Math.min(max, Math.max(min, seconds));
};

export const getSequenceVideoDurationOptions = (provider) => {
  const wanx = String(provider || "").trim().toLowerCase() === WANX_VIDEO_PROVIDER
    || isWanxVideoModel(provider);
  const min = wanx ? 2 : 1;
  const max = wanx ? 30 : 16;
  return Array.from({ length: max - min + 1 }, (_, index) => min + index);
};
